interface OgTagsSchemaProps {
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  ogType?: string;
  ogImage?: string;
}

const OgTagsSchema: React.FC<OgTagsSchemaProps> = ({ ogTitle, ogDescription, ogUrl, ogType, ogImage }) => {
  return (
    <>
      <meta property="og:title" content={ogTitle  || ''} />
      <meta property="og:description" content={ogDescription || ''} />
      <meta property="og:url" content={ogUrl || ''} />
      <meta property="og:type" content={ogType || ''} />
      <meta property="og:site_name" content="Caroma Specify" />
      <meta property="og:image" content={ogImage || ''} />
    </>
  );
};

export default OgTagsSchema;
